import loadScriptOrStyle from "./loadScriptOrStyle.js";
export default function loadScript(src, prefix, attrs) {
  return loadScriptOrStyle("script", src, prefix, attrs);
}
//# sourceMappingURL=loadScript.js.map